import React from 'react';

import { SHOP_CHIP_STATUS } from '@types';

import * as Styled from './tag-chip.styled';

type OwnProps = {
	state: SHOP_CHIP_STATUS;
	name: string;
};

const TagChip: React.FC<OwnProps> = ({ state, name }) => {
	return <Styled.Wrapper $state={state}>{name}</Styled.Wrapper>;
};

export default TagChip;
